import { createContext } from "react";

export type ResetStoresContextType = {
  resetStores: () => void;
};
export const ResetStoresContext = createContext<
  ResetStoresContextType | undefined
>(undefined);
